import { FlexWrapper, Skeleton } from '@intigral/shared';
import { UpcomingItem, UpcomingItemProps } from '../UpcomingItem';
import styles from './upcomlist.module.sass';
import cn from 'classnames';
import React from 'react';

interface BaseProps extends React.HTMLAttributes<HTMLDivElement> {
    isLoading?: boolean;
}

interface LoadingProps extends BaseProps {
    isLoading: boolean;
    month?: string;
    year?: number;
    items?: UpcomingItemProps[] | React.ReactNode[];
}

interface LoadedProps extends BaseProps {
    isLoading?: boolean;
    month: string;
    year: string;
    items: UpcomingItemProps[] | React.ReactNode[];
}

type UpcomingListProps = LoadingProps | LoadedProps;

export const UpcomingList = ({ month, year, items, isLoading, ...props }: UpcomingListProps) => {
    if (isLoading) {
        return <UpcomingItem isLoading />;
    }

    const isPropsArray = (items: UpcomingListProps['items']): items is UpcomingItemProps[] => {
        return typeof items?.[0] === 'object' && !React.isValidElement(items[0]);
    };

    return (
        <div className={styles.holder}>
            <div>
                {(month || year) && (
                    <div className={styles.current}>
                        <strong>{month}</strong>
                        <span>{year}</span>
                    </div>
                )}
            </div>
            <FlexWrapper flexDirection="column" gap="2x" {...props} className={cn(styles.upcomlist, props.className)}>
                {/* {items && items.map((item) => <UpcomingItem {...item} key={item.title} />)} */}
                {isPropsArray(items)
                    ? items.map((item) => <UpcomingItem key={item.id} {...item} />)
                    : items?.map((item, index) => <React.Fragment key={index}>{item}</React.Fragment>) ?? ''}
            </FlexWrapper>
            <div></div>
        </div>
    );
};
